import { SET_NAV_TOOLBAR_ITEMS, CLEAR_NAV_TOOLBAR_ITEMS } from "./actionTypes";

/**
 *
 * @param {Array} toolbarItems Array of any react elements
 */
export function setNavToolbarItems(toolbarItems) {
  return {type: SET_NAV_TOOLBAR_ITEMS, toolbarItems};
}

export function clearNavToolbarItems() {
  return {type: CLEAR_NAV_TOOLBAR_ITEMS};
}
